import { useEffect, useState } from "react";
import Button from "../../components/button";
import Loader from "../../components/loader";

import { openPopUp } from "../../components/popUp";
import { useAppContext } from "../../context/appContext";
import { useDashboardContext } from "../../context/dashboardContext";
import { SettingsResponseDTO } from "../../openapi-generated-client";
import UpdateEmailPopUp from "../../pageparts/popup/updateEmailPopUp";
import UpdatePasswordPopUp from "../../pageparts/popup/updatePasswordPopUp";
import { formatDate, formatTime } from "../../utils/dateUtils";
import "./dashboardSettingsPage.css";

export default function DashboardSettingsPage() {

    const {sessionId} = useDashboardContext(); 
    const {settingsController} = useAppContext();

    const [data, setData] = useState<SettingsResponseDTO>();

    async function fetchData() {
        setData((await settingsController.getSettings(sessionId)).data);
    }

    useEffect(() => {
        fetchData();
    }, []);

    if(data == undefined) return <Loader/>;

    return <div className="page">
            <h2>Account</h2>
            <div className="txoria-setting-button-text-field">
                <div className="txoria-text-field">
                    <label>Email</label>
                    <a>{data.email}</a>
                </div>
                <Button onClick={() => {
                    openPopUp(<UpdateEmailPopUp/>);
                }}>Change Email</Button>
            </div>
            <div className="txoria-setting-button-text-field">
                <div className="txoria-text-field">
                    <label>Password</label>
                    <a>last changed: {formatDate(new Date(data.lastPasswordChange))} {formatTime(new Date(data.lastPasswordChange))}</a>
                </div>
                <Button onClick={() => {
                    openPopUp(<UpdatePasswordPopUp/>);
                }}>Change Password</Button>
            </div>
        </div>
}